module.exports = __webpack_public_path__ + "img/ic-stats-inactive.587616e8.svg";